module.exports = __webpack_public_path__ + "img/power_button_white.aa64be46.svg";